import { gql } from '@apollo/client';

export const ARCHIVE_INSTITUTION = gql`
  mutation archiveInstitution($id: ID!) {
    institution: archiveInstitution(id: $id) {
      id
    }
  }
`;
